export default __webpack_public_path__ + "assets/images/Pie Chart-dd2bec3c7aba31f0ea754639e390daed.svg";